<template>
  <div class="send-no-tip">
    <el-dialog title="提示" :visible.sync="visible" :before-close="closeDialog" width="540px" :close-on-click-modal="false">
      <div>
        <p style="margin:0 0 24px 0">以下箱号不符合国际规范，请确认后再发送～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" class="submit-btn" @click="enterGo">我已确认，继续</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "SendNoTip",
  props: {
    visible: Boolean,
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'containerNo', label: '箱号'}
        ]
      }
    }
  },
  created() {
    this.WTableOpts.data = this.dialogData.content
  },
  methods: {
    // 确认 继续
    enterGo(){
      this.$emit("enterGo", this.dialogData)
    },
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    }
  }
}
</script>

<style scoped lang="less">
.send-no-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 146px;
    padding: 0;
  }
  /deep/.el-dialog__body {
    position: relative;
  }
  .mix-tip {
    background: #fff5ed;
    color: #ed6a0c;
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding-left: 16px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
  /deep/.el-link {
    vertical-align: top;
  }
}
</style>